/**
 * Product Specifications Drawer
 * Opens/closes the VIEW DETAILS drawer from the right side
 * Handles tab switching between Details and Body Guide
 */

document.addEventListener('DOMContentLoaded', function () {
    const openButtons = document.querySelectorAll('[data-js-open-specs-drawer]');
    const drawer = document.querySelector('[data-js-specs-drawer]');
    const closeButton = document.querySelector('[data-js-close-specs-drawer]');
    const overlay = document.querySelector('[data-js-specs-overlay]');

    if (openButtons.length === 0 || !drawer) return;

    // Move drawer to body to ensure it covers everything (fixes z-index/stacking context issues)
    document.body.appendChild(drawer);

    // Open drawer
    function openDrawer(targetTabName) {
        drawer.classList.add('is-open');
        document.body.classList.add('specs-drawer-open');
        
        if (targetTabName) {
            const tabBtn = drawer.querySelector('.product-specs-tab[data-tab="' + targetTabName + '"]');
            if (tabBtn) {
                tabBtn.click(); // reuse existing tab logic
            }
        }
    }

    // Close drawer
    function closeDrawer() {
        drawer.classList.remove('is-open');
        document.body.classList.remove('specs-drawer-open');
    }

    // Event listeners
    openButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            const targetTab = this.getAttribute('data-js-open-specs-drawer') || 'details';
            openDrawer(targetTab);
        });
    });

    if (closeButton) {
        closeButton.addEventListener('click', closeDrawer);
    }

    if (overlay) {
        overlay.addEventListener('click', closeDrawer);
    }

    // Close on ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
            closeDrawer();
        }
    });

    // Tab switching functionality
    const tabs = drawer.querySelectorAll('.product-specs-tab');
    const tabContents = drawer.querySelectorAll('.product-specs-tab-content');

    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            const targetTab = this.getAttribute('data-tab');

            // Remove active class from all tabs and contents
            tabs.forEach(function (t) {
                t.classList.remove('is-active');
            });
            tabContents.forEach(function (c) {
                c.classList.remove('is-active');
            });

            // Add active class to clicked tab and corresponding content
            this.classList.add('is-active');
            const targetContent = drawer.querySelector('[data-tab-content="' + targetTab + '"]');
            if (targetContent) {
                targetContent.classList.add('is-active');
            }
        });
    });

    // Lightbox functionality for Body Guide image
    const lightboxTrigger = drawer.querySelector('[data-js-lightbox-trigger]');
    const lightbox = drawer.querySelector('[data-js-lightbox]');
    const lightboxCloseButtons = drawer.querySelectorAll('[data-js-lightbox-close]');

    if (lightboxTrigger && lightbox) {
        // Open lightbox
        lightboxTrigger.addEventListener('click', function () {
            lightbox.classList.add('is-open');
        });

        // Close lightbox
        lightboxCloseButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                lightbox.classList.remove('is-open');
            });
        });

        // Close on ESC key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
                lightbox.classList.remove('is-open');
            }
        });
    }
});

